export default __webpack_public_path__ + "static/media/Yoga-relax.5692a7ed.png";